
import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Member } from '@/models/member';
import MemberAssessmentTree from '@/components/coach/assessmentByMember/MemberAssessmentTree.vue';
import AdditionalAssessments from '@/components/coach/assessment/AdditionalAssessments.vue';
import MarkMoveModal from '@/components/coach/members/MarkMoveModal.vue';
import { GroupSchemeScope } from '@/components/mixins/schemescope';
import { SchemeNodeModel } from '@/models/schemeNodeModel';

@Component({
  components: {
    MemberAssessmentTree,
    AdditionalAssessments,
    MarkMoveModal,
  },
  name: 'MemberAssessment',
})
export default class MemberAssessment extends mixins(GroupSchemeScope) {
  /**
   * memberUuid
   * Current members UUID.
   *
   * @property {string}
   */
  @Prop() private memberUuid!: string;

  private search = '';
  private showMoveModal = false;

  created() {
    this.$store.dispatch('nav/calculateStyle', { schemeNodeId: '', schemeSlug: this.slug, updateTheme: true });
  }

  /**
   * Returns the member from the store via the ID.
   * NOTE - The store value will be updated which is why this will be fetched like this and not passed in the params.
   */
  get member(): Member {
    return this.$store.getters['groupMembers/memberById'](this.groupId, this.memberUuid);
  }

  get memberLevels(): string[] {
    const nodeIds = this.getMemberActiveLevels(this.member);

    // If group has levels (from coursepro) then always show first level unless complete
    if (this.groupLevels !== null && !this.group.assessment_level_limit) {
      const firstLevel = this.getLevelsInOrder(this.groupLevels)[0];
      const completedLevels = Object.keys(this.member.assessments.complete || []);
      if (!nodeIds.includes(firstLevel) && !completedLevels.includes(firstLevel)) {
        nodeIds.push(firstLevel);
      }
    }
    return nodeIds;
  }

  get memberAssessmentTree(): Array<SchemeNodeModel> {
    return this.schemeAllAssessableLevels(this.memberLevels, true);
  }

  get passedLevelTree() {
    if (this.group.assessment_level_limit) {
      return [];
    }
    return this.schemeAllCompleteLevels(Object.keys(this.member.assessments.complete), true);
  }

  get memberMoveLevel() {
    return this.member.move_remote_node_id ? this.getNodeName(this.member.move_remote_node_id) : '';
  }

  get allowMove() {
    return 'move_remote_node_id' in this.member;
  }

  async cancelMove() {
    const success = await this.$store.dispatch('groupMembers/cancelMarkForMove', {
      member: this.member,
      groupId: this.groupId,
    });
    if (success !== true) {
      this.$alert('error', this.$t('member.cancel_move_class_failed'));
    }
  }

  getAssessByHeading() {
    if (!this.group.is_slot) {
      return this.$t('assess-by-member.title');
    } else {
      return this.$t('assess-by-member.title-pupil');
    }
  }
}
